import { StyleSheet } from 'react-native';
import { luxColors } from '@alucio/lux-ui';
export const styles = StyleSheet.create({
    Container: {
        flex: 1,
        flexDirection: 'column',
        marginLeft: 14,
        marginRight: 14,
        padding: 10,
    },
    DisabledMessage: {
        color: '#C48129',
        marginBottom: 32,
    },
    Title: {
        color: '#75839E',
        fontSize: 13,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        marginTop: 4,
        marginBottom: 4,
    },
    required: {
        color: '#FF0000',
        paddingLeft: 5,
        paddingRight: 5,
    },
    TitleContainer: {
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'center',
    },
    errorLabel: {
        color: '#CB3831',
        fontSize: 13,
        fontWeight: 'bold',
    },
    radioItem: {
        color: '#222B45',
    },
    EditHeaderContainer: {
        alignItems: 'center',
        borderBottomColor: luxColors.formFieldBorder.primary,
        borderBottomWidth: 1,
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        paddingBottom: 21,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 21,
    },
    EditHeader: {
        color: '#2C3651',
        fontSize: 22,
        fontWeight: 'bold',
    },
    EditHeaderButtonContainer: {
        flexDirection: 'row',
        flexWrap: 'nowrap',
    },
    EditHeaderButton: {
        borderRadius: 4,
        borderWidth: 0,
        paddingLeft: 10,
        marginRight: 10,
    },
    EditHeaderSaveButton: {
        backgroundColor: '#0095FF',
    },
    EditHeaderDefaultButton: {
        backgroundColor: '#EDF1F7',
    },
    IconTextBlack: {
        fontSize: 18,
        color: '#2E3A59',
    },
    IconTextWhite: {
        fontSize: 18,
        color: '#FFF',
    },
    IconTextRed: {
        fontSize: 18,
        color: '#FF3D71',
    },
    OptionsContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    ThumbnailContainer: {
        marginTop: 33,
        marginRight: 20,
        borderWidth: 1,
        borderColor: luxColors.formFieldBorder.primary,
    },
    EditFooterContainer: {
        backgroundColor: '#F7F9FC',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        paddingBottom: 32,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 24,
        marginTop: 5,
    },
    EditFooterInfoContainer: {
        borderBottomColor: luxColors.formFieldBorder.primary,
        borderBottomWidth: 1,
        borderStyle: 'solid',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        marginBottom: 32,
    },
    EditFooterInfoTitle: {
        color: '#8F9BB3',
        fontSize: 13,
        fontWeight: 'bold',
        justifyContent: 'flex-start',
        textTransform: 'uppercase',
        paddingBottom: 4,
    },
    EditFooterInfoText: {
        color: '#8F9BB3',
        fontSize: 13,
        fontWeight: 'normal',
    },
    EditFooter: {
        paddingBottom: 18,
    },
    EditFooterButtonContainer: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
    PillContainer: {
        borderRadius: 5,
        backgroundColor: '#AABBCC',
        padding: 5,
    },
    StatusDescriptionContainer: {
        marginLeft: 20,
        padding: 5,
    },
    CounterContainer: {
        alignItems: 'center',
        flex: 1,
        flexDirection: 'row-reverse',
    },
    CharacterCounter: {
        color: '#8F9BB3',
        fontSize: 14,
        fontWeight: 'normal',
        justifyContent: 'flex-end',
    },
    ScrollViewContainer: {
        marginTop: 20,
    },
    HelpToolTipIconStyle: {
        paddingLeft: 5,
        height: 16,
        width: 16,
        color: luxColors.title.primary,
    },
    NoMarginPadding: {
        marginLeft: 0,
        marginRight: 0,
        padding: 0,
    },
});
//# sourceMappingURL=Styles.js.map